/**
 * templatesフォルダ内のRouteを決定する
 */

import React from 'react';
import {Route, Switch} from 'react-router';
import Auth from './Auth';
import { SignIn, CleanPlaces, MainPage, LoginedMainPage, SignUp, LoginedCleanPlaces } from './templates';

const Router = () => {
    return (
        <Switch>
            <Route exact path="/SignIn" component={SignIn}/>
            <Route exact path="/SignUp" component={SignUp}/>
            <Auth>
                {/* TODO:Googleログインを使いたいので逆にしています、のちに直す */}
                <Route exact path="/" component={MainPage}/>
                <Route exact path="/CleaningPlaces" component={CleanPlaces}/>
                <Route exact path="/" component={LoginedMainPage}/>
                <Route exact path="/CleaningPlaces" component={LoginedCleanPlaces}/>
            </Auth>
        </Switch>
    )
}
export default Router;